import type {
  ApiResponseList,
  ApiResponseSingle,
  MutationConfig,
  QueryConfig
} from '@/types/response'

import { api as axios } from '@/lib/axios'
import type { Option } from '@/types/common'

import type {
  DinasBppKotaKabupaten,
  DinasBppKotaKabupatenListParams
} from './types'

interface KotaKabExportFilter {
  page?: number
  per_page?: number
  q?: string
  province?: Option | null
  city?: Option | null
}

const BASE_URL = '/kelembagaan/dinas-kota'

export const getList = (
  params?: DinasBppKotaKabupatenListParams
): QueryConfig<ApiResponseList<DinasBppKotaKabupaten>> => ({
  queryKey: ['klb-penyuluh', 'kotakab', 'list', params],
  queryFn: async () => {
    const response = await axios.get<ApiResponseList<DinasBppKotaKabupaten>>(
      BASE_URL,
      { params }
    )
    return response.data
  }
})

export const getById = (
  id: string
): QueryConfig<ApiResponseSingle<DinasBppKotaKabupaten>> => ({
  queryKey: ['klb-penyuluh', 'kotakab', 'detail', id],
  queryFn: async () => {
    const response = await axios.get<ApiResponseSingle<DinasBppKotaKabupaten>>(
      `${BASE_URL}/${id}`
    )
    return response.data
  }
})

export const create = (): MutationConfig<
  ApiResponseSingle<DinasBppKotaKabupaten>,
  any
> => ({
  mutationFn: async (data: any) => {
    const response = await axios.post<ApiResponseSingle<DinasBppKotaKabupaten>>(
      BASE_URL,
      data
    )
    return response.data
  }
})

export const update = (): MutationConfig<
  ApiResponseSingle<DinasBppKotaKabupaten>,
  { id: string; data: any }
> => ({
  mutationFn: async ({ id, data }) => {
    const response = await axios.put<ApiResponseSingle<DinasBppKotaKabupaten>>(
      `${BASE_URL}/${id}`,
      data
    )
    return response.data
  }
})

export const remove = (): MutationConfig<
  ApiResponseSingle<DinasBppKotaKabupaten>,
  string
> => ({
  mutationFn: async (id: string) => {
    const response = await axios.delete<
      ApiResponseSingle<DinasBppKotaKabupaten>
    >(`${BASE_URL}/${id}`)
    return response.data
  }
})

export const exportData = (filter?: KotaKabExportFilter) => ({
  mutationFn: async () => {
    const response = await axios.get<{
      status: string
      url?: string | null
      job_id?: string
      message?: string
      progress?: number
    }>(`${BASE_URL}/export`, {
      params: {
        page: filter?.page,
        per_page: filter?.per_page,
        q: filter?.q || undefined,
        id_provinsi: filter?.province?.value || undefined,
        id_kota: filter?.city?.value || undefined
      }
    })
    return response.data
  }
})
